import './SellerProfile.scss';
import { Box } from '@mui/material';
import { showAPIerror } from './APIs/Helpers';
import { sllrProfAxios } from '../../pages/SellerProfile/APIs/axiosDefault';
//import { SpAPIgetAllUsers } from './APIs/SellerProfileAPI';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ApiCredentials from './ApiCredentials/ApiCredentials';
import CompanyProfile from './CompanyProfile/CompanyProfile';
//import getSellerAndUserIDs from './APIs/GetSellerUserIDs';
import NotificationsRecipients from './NotificationsRecipients/NotificationsRecipients';
import OnboardingCompleteModal from '../../components/SellerProfile/OnboardingCompleteModal/OnboardingCompleteModal';
import SellerProfileHeaderContainer from '../../components/SellerProfile/SellerProfileHeaderContainer/SellerProfileHeaderContainer';
import SPLandingPage from './LandingPage/SPLandingPage';
import SPQuestionnaire from './Questionnaire/SPQuestionnaire';
import SPUserSettings from './EditMySettings/EditMySettings';
import SuccessPopUp from '../../components/SellerProfile/SuccessPopUp/SuccessPopUp';
import UserList from './UserList/UserList';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  setApiStatus, getStatus,
  fecthAllUsers, setUsers,
  getUserIdAndSellerId,
  setShowSuccessPopUp, setSpPageText, setOnboardCompletePopupDetails,
  fetchCompanyProfileStart
} from '../../redux/slices/sellerProfileSlice';

// export const UserContext = createContext({
//   apiCreds: {} as any,
//   apiCredTypes: {} as any,
//   //apiStatus: '' as string,
//   compProfile: {} as any,
//   coName: '' as string,
//   defaultCompData: {} as any,
//   disabledBttn: {} as any,
//   errorMsg: '' as string,
//   filterUsers: '' as string,
//   formLoading: false as boolean,
//   formUpdates: {} as any,
//   isAddingUser: false as boolean,
//   isAdmin: false as boolean,
// isFrench: false as boolean,
//   modalType: '' as string,
//   notificationRecipients: {} as any,
//   notificationTypes: {} as any,
//   notifRecips: {} as any,
//   onboardingStatus: {} as any,
//   seller_id: '' as string,
//   showingUsers: 'true' as string,
//   showSuccessPopUp: '' as string,
//   onboardCompletePopupDetails: {
//     show: false,
//     navigate: false,
//     close: false
//   } as any,
//   spPageText: '' as string,
//   surveyDetails: {} as any,
//   user_id: '' as string,
//   users: {} as any,
//   setApiCreds: (user: any) => { },
//   setApiCredTypes: (filterUsers: any) => { },
//   //setApiStatus: (showSuccessPopUp: string) => {},
//   setCompProfile: (user: any) => { },
//   setCoName: (user: string) => { },
//   setDefaultCompData: (user: any) => { },
//   setDisabledBttn: (user: any) => { },
//   setErrorMsg: (filterUsers: string) => { },
//   setFilterUsers: (filterUsers: string) => { },
//   setFormLoading: (formLoading: boolean) => { },
//   setFormUpdates: (user: string) => { },
//   setIsAddingUser: (isAddingUser: boolean) => { },
//   setModalType: (user: string) => { },
//   setNotificationRecipients: (user: any) => { },
//   setNotificationTypes: (filterUsers: any) => { },
//   setNotifRecips: (user: any) => { },
//   setOnboardingStatus: (user: any) => { },
//   setShowingUsers: (showingUsers: string) => { },
//   setShowSuccessPopUp: (showSuccessPopUp: string) => { },
//   setOnboardCompletePopupDetails: (details: any) => { },
//   setSurveyDetails: (user: any) => { },
//   setUser_id: (user: string) => { },
//   setUsers: (user: any) => { }
// });

// export const useSellerProfile = () => {
//   return useContext(UserContext);
// };

const SellerProfile = ({ coName, setCoName, logoHeight }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  // const [apiCreds, setApiCreds] = useState<object>({});
  // const [apiCredTypes, setApiCredTypes] = useState<object>({});
  // const [compProfile, setCompProfile] = useState<object>({});
  // const [defaultCompData, setDefaultCompData] = useState<object>({});
  // const [disabledBttn, setDisabledBttn] = useState({});
  // const [errorMsg, setErrorMsg] = useState('');
  // const [filterUsers, setFilterUsers] = useState('');
  // const [formLoading, setFormLoading] = useState(false); //a bit hacky, but otherwise the button flashes at top before form generates/loads (button is separate component so can easily adjust placement relative to form fields)...
  // const [formUpdates, setFormUpdates] = useState({});
  // const [isAddingUser, setIsAddingUser] = useState<boolean>(false);
  // const [isFrench, setIsFrench] = useState(false);
  // const [modalType, setModalType] = useState('');
  // const [notificationRecipients, setNotificationRecipients] = useState<object>(
  //   {}
  // );
  // const [notificationTypes, setNotificationTypes] = useState<object>({});
  // const [notifRecips, setNotifRecips] = useState<object>({});
  // const [onboardingStatus, setOnboardingStatus] = useState<object>({});
  // const [showingUsers, setShowingUsers] = useState('true');
  //const [showSuccessPopUp, setShowSuccessPopUp] = useState('');
  //const [onboardCompletePopupDetails, setOnboardCompletePopupDetails] =
  // useState({
  //   show: false,
  //   navigate: false,
  //   close: false
  // });
  //const [spPageText, setSpPageText] = useState(data.dashboard);
  // const [surveyDetails, setSurveyDetails] = useState<object>({});
  const [trackSSOattempts, setTrackSSOattempts] = useState(0);
  const location = useLocation();
  let onPage = location.pathname.split('/').pop();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('md'));
  const { apiStatus, users, seller_id, user_id, isAdmin, showSuccessPopUp, successType = 'success',spPageText, onboardCompletePopupDetails } = useSelector((state: any) => state.sellerProfile);

  const pages = {
    notifications: {
      title: t('sellerProfile.dashboard.updateNotificationList'),
      component: <NotificationsRecipients />
    },
    users: {
      title: t('sellerProfile.dashboard.updateUserList'),
      component: <UserList />
    },
    profile: {
      title: t('sellerProfile.dashboard.updateProfileDetails'),
      component: <CompanyProfile />
    },
    questionnaire: {
      title: t('sellerProfile.dashboard.questionnaire'),
      component: <SPQuestionnaire />
    },
    'user-settings': {
      title: t('sellerProfile.dashboard.mySettings'),
      component: <SPUserSettings />
    },
    'api-credentials': {
      title: t('sellerProfile.dashboard.updateAPICredentials'),
      component: <ApiCredentials />
    }
  };

  // const context = {
  //   apiCreds,
  //   apiCredTypes,
  //   apiStatus,
  //   compProfile,
  //   coName,
  //   defaultCompData,
  //   disabledBttn,
  //   errorMsg,
  //   filterUsers,
  //   formLoading,
  //   formUpdates,
  //   isAddingUser,
  //   isAdmin,
  //   isFrench,
  //   modalType,
  //   notificationRecipients,
  //   notificationTypes,
  //   notifRecips,
  //   onboardingStatus,
  //   seller_id,
  //   setCoName,
  //   showingUsers,
  //   showSuccessPopUp,
  //   onboardCompletePopupDetails,
  //   spPageText,
  //   surveyDetails,
  //   user_id,
  //   users,
  //   setApiCreds,
  //   setApiCredTypes,
  //   setApiStatus,
  //   setCompProfile,
  //   setDefaultCompData,
  //   setDisabledBttn,
  //   setErrorMsg,
  //   setFilterUsers,
  //   setFormLoading,
  //   setFormUpdates,
  //   setIsAddingUser,
  //   setModalType,
  //   setNotificationRecipients,
  //   setNotificationTypes,
  //   setNotifRecips,
  //   setOnboardingStatus,
  //   setShowingUsers,
  //   setShowSuccessPopUp,
  //   setOnboardCompletePopupDetails,
  //   setSurveyDetails,
  //   setUser_id,
  //   setUsers
  // };

  useEffect(() => {
    // setIsFrench(i18n.language === 'fr');

    //get and set user_id and seller_id
    const getSellerUserIDs = () => {
      if (seller_id === '' && user_id === '') {
        dispatch(getUserIdAndSellerId());
      }
    };
    if (sllrProfAxios.defaults.headers.common['Authorization'] !== undefined) {
      getSellerUserIDs();
    } else if (trackSSOattempts < 3) {
      setTimeout(() => {
        const track = trackSSOattempts + 1;
        setTrackSSOattempts(track);
        getSellerUserIDs();
      }, 2000);
    } else {
      showAPIerror(
        { response: { status: 403 } },
        setShowSuccessPopUp, setApiStatus,
        spPageText,
        'authorizationHeader'
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sllrProfAxios.defaults.headers.common]);

  useEffect(() => {
    if (seller_id !== '' && isAdmin) {
      setApiStatus('Loading...');
      dispatch(fecthAllUsers({ seller_id, user_id }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seller_id, user_id, dispatch, isAdmin]);

  useEffect(() => {
    if (seller_id !== '') {
      dispatch(fetchCompanyProfileStart({ seller_id, language: i18n.language }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seller_id, i18n.language]);

  useEffect(() => {
    if (users.length > 0) {
      const checkIfAdminUser = () => {
        const currUser = users.find((user) => user.user_id === user_id);
        return currUser?.role_id === 'USR001';
      };
      const isAdminUser = checkIfAdminUser();
      dispatch(setUsers(users));

      if (isAdminUser) {
        dispatch(getStatus({ seller_id }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [users, user_id, seller_id, dispatch]);

  useEffect(() => {
    // setIsFrench(i18n.language === 'fr');
    dispatch(setSpPageText(t('sellerProfile.dashboard', { returnObjects: true })));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  const loaded = (users && Object.keys(users).length > 0) || !isAdmin;
  const isError = successType === 'error';

  return loaded && apiStatus === 'Loading...' ? (
    // <UserContext.Provider value={{ ...context }}>
    <div
      className="sellerProfile"
      style={{ marginTop: `${logoHeight - (mobile ? 50 : 30)}px` }}
    >
      {onPage === 'seller-profile' && <SPLandingPage />}
      <Box
        role={isError ? 'alert' : 'status'}
        aria-live={isError ? 'assertive' : 'polite'}
        aria-atomic="true"
        sx={{
          position: 'absolute',
          width: 1,
          height: 1,
          overflow: 'hidden',
          clip: 'rect(0 0 0 0)',
        }}
      >
        {showSuccessPopUp}
      </Box>
      {showSuccessPopUp !== '' && (
        <SuccessPopUp
          topPx={onboardCompletePopupDetails.show ? '120px' : '180px'}
        />
      )}
      <OnboardingCompleteModal
        data={t('sellerProfile.dashboard.onboardingComplete', { returnObjects: true })}
        profileName={coName}
        open={onboardCompletePopupDetails.show}
        handleOnClickBtn={() => {
          if (onboardCompletePopupDetails.navigate) {
            dispatch(setOnboardCompletePopupDetails((prev) => ({
              ...prev,
              show: false

            })));
            navigate(`/${i18n.language}/seller-profile`);
          } else {
            dispatch(setOnboardCompletePopupDetails((prev) => ({
              ...prev,
              show: false

            })));
          }
        }}
      />
      {onPage !== 'seller-profile' && (
        <SellerProfileHeaderContainer
          title={onPage && pages[onPage]['title']}
          render={() => onPage && pages[onPage]['component']}
        />
      )}
    </div>
    // </UserContext.Provider>
  ) : (
    <Box
      sx={{
        width: '100%',
        textAlign: 'center',
        padding: '50vh 20px',
        fontWeight: 'bold',
        fontSize: '14px'
      }}
      dangerouslySetInnerHTML={{ __html: apiStatus }}
    ></Box>
  );
};

export default SellerProfile;
